/**
 * @module portal\home
 */
import { State, Action } from "vuex-class";
import axios from "axios";
import { API_BASE_URL } from "@/utils/conf";
import GhBase from "@/components/ghBase";
import { RouteConfig } from "vue-router";
import { Mixins, Component } from "vue-property-decorator";
import GhClassService from "@/utils/mixins/clsService";
import { MethodService } from "@/utils/serviceModel";
import { VNode } from "vue";
import ModuleService from '@/utils/mixins/moduleService';

@Component
export default class Home extends ModuleService {
  private url = API_BASE_URL + "api/login";
  private images = [
    {
      title: "公司介绍",
      src: "1.png",
      aspect: 2
    },
    {
      title: "主营业务",
      src: "2.png",
      aspect: 2
    },
    {
      title: "系统蓝图",
      src: "3.png",
      aspect: 2
    },
    {
      title: "生产看板",
      src: "4.png",
      aspect: 2
    },
    {
      title: "系统架构",
      src: "5.png",
      aspect: 2
    },
    {
      title: "集中控制",
      src: "6.png",
      aspect: 2
    }
  ];

  @State(state => state.menus)
  protected menus: IndexObject[];
  @Action("fetchMenus")
  private fetchMenus;
  @Action("fectchSouceTimestamp")
  private getSourceTimestamp;

  private isBusy = false;

  private result = {};

  @State(state => state.appconfig)
  private setting: IndexObject

  private dialog = false;

  private openLogin() {
    this.dialog = true;
  }

  private get loginError() {
    let res = this.result as ILoginResult;
    if (res.error) {
      return true;
    }
    return false;
  }

  private async login() {
    let val = await this.$validator.validateAll();
    if (val) {
      try {
        this.isBusy = true;
        let result = await axios.post(this.url, {
          data: {
            site: this.loginer.site,
            name: this.loginer.name,
            pwd: this.loginer.pwd
          }
        });
        let res = result.data as ILoginResult;
        this.result = res;
        if (res.success) {
          this.loginer.Site = res.site;
          this.loginer.User = res.user;
          this.$cookies.set("site", this.loginer.site);
          this.$cookies.set("user_id", res.user.Id);
          this.$cookies.set("token", res.user.token);
          try {
            await this.getSourceTimestamp();
            await this.fetchMenus();
            await this.initalMenus();
            this.$router.push({
              name: "main"
            });
          } catch (error) { }
        }
      } catch (error) {
      } finally {
        this.isBusy = false;
      }
    }
  }

  private async initalMenus() {
    let rs: RouteConfig = {
      name: "main",
      path: "/main",
      component: () => import("@/portal/main/main")
    };
    let children: RouteConfig[] = [
      {
        name: "column",
        path: "/portal/column",
        component: () => import("@/portal/table/column/column")
      },
      {
        name: "/portal/menu/config",
        path: "/portal/menu/config",
        component: () => import("@/portal/menu/config/config")
      }
    ];

    let dynamicPages: IndexObject[] = [];
    for (const menu of this.menus) {
      this.traceMenuNode(menu, children, dynamicPages);
    }
    let pages: IndexObject = {};
    if (dynamicPages.length > 0) {
      dynamicPages.forEach(m => {
        pages[m.Id] = m;
      });
    }
    let ids = Object.keys(pages);
    await this.loadPages(rs, ids, pages, children);
  }

  private traceMenuNode(
    menu: IndexObject,
    rs: RouteConfig[],
    dyPages: IndexObject[]
  ) {
    let name = menu.PageName ? menu.PageName : menu.Cd;
    let path = menu.Path ? menu.Path : "/" + menu.Cd;
    let r: RouteConfig = {
      name,
      path,
      component: undefined,
      props: undefined
    };
    if (menu.Url) {
      let url = menu.Url as string;
      let patter = /^\/portal\//;
      if (patter.test(url)) {
        let path = url.replace(patter, "");
        r.component = () => import("@/portal/" + path);
      } else {
        r.component = () => import("@/views" + menu.Url);
      }
    } else {
      if (menu.dynamic) {
        if (this.isUpdateCode(menu.Id)) {
          dyPages.push(menu);
        } else {
          let json = localStorage.getItem(menu.Id);
          if (json) {
            let obj = JSON.parse(json);
            let code = obj.code;
            if (code) {
              if (menu.IsTemplate) {
                r.component = this.resovleTemplate();
                r.props = this.getTemplateData(code);
              }
              else {
                r.component = this.resolveCode(code);
              }
            }
          }
        }
      }
    }
    if (r.component) {
      rs.push(r);
    }
    if (menu.children) {
      let children = menu.children as IndexObject[];
      for (const child of children) {
        this.traceMenuNode(child, rs, dyPages);
      }
    }
  }

  /** 是否需要更新组件 */
  private isUpdateCode(id: string) {
    let json = localStorage.getItem(id);
    if (json) {
      let obj = JSON.parse(json);
      if (obj.ver) {
        let ver = this.timestamp[id];
        if (ver === obj.ver) {
          return false;
        }
      }
    }

    return true;
  }

  private async parseCode(id) {
    let res = await this.getCodeMethod.invokeAsyn({ id });
    if (res.data.isSuccess) {
      try {
        let componet = this.resolveCode(res.data.data);
        let ver = this.timestamp[id];
        if (ver) {
          let obj = { ver, code: res.data.data };
          localStorage.setItem(id, JSON.stringify(obj));
        }
        return componet;
      } catch (error) {
        console.log(error);
      }
    }
  }

  created() {
    let site = this.$cookies.get("site");
    if (site) {
      this.loginer.site = site;
    }
  }

  private getCodeMethod: MethodService = new MethodService(
    "plat.page",
    "PageCodeService",
    "get_page_code"
  );

  private test() {
  }
}
